import React from 'react';
import { ColorScheme } from 'mini-color/lib/schema/ColorScheme';
import { HeaderIcon } from './HeaderIcon';
import type { HeaderIconType } from './HeaderIcon.types';

export interface HeaderIconsProps {
    icons: HeaderIconType[];
    rightAligned?: boolean;
    colorScheme?: ColorScheme;
    className?: string;
    tabIndex?: number;
}

const styles = require('./HeaderIcons.scss');
const cx = require('classnames').bind(styles);

export const HeaderIcons = (props: HeaderIconsProps) => {
    const { icons, rightAligned = false, className } = props;

    if (!icons.filter(Boolean).length) {
        return null;
    }

    const innerContent: JSX.Element[] = icons.map(
        (icon: HeaderIconType, index: number) =>
            icon && (
                <HeaderIcon
                    key={`HeaderIcon_${index}`}
                    {...icon}
                    ref={icon.iconRef}
                    iconStyle={cx(icon.iconStyle, styles.icon)}
                />
            )
    );
    return (
        <div className={cx(styles.iconsContainer, rightAligned && styles.rightAligned, className)}>
            {innerContent}
        </div>
    );
};
